import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const [versionInfo, setVersionInfo] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Fetch version information from backend
    const fetchVersion = async () => {
      try {
        const response = await axios.get('/api/version');
        setVersionInfo(response.data);
      } catch (error) {
        console.error('Failed to fetch version:', error);
      }
    };

    fetchVersion();
  }, []);

  if (!versionInfo) return null;

  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center text-sm text-gray-600 dark:text-gray-400">
          <div className="mb-2 sm:mb-0">
            <span className="font-semibold text-gray-900 dark:text-white">FirmFlow</span>
            {' '}&copy; {new Date().getFullYear()}
          </div>

          <div className="flex items-center space-x-4">
            <button
              onClick={() => setShowDetails(!showDetails)}
              className="hover:text-pastel-purple-600 dark:hover:text-pastel-purple-400 transition-colors flex items-center space-x-1"
              title={t('footer.clickForDetails')}
            >
              <span>v{versionInfo.version}</span>
              {versionInfo.git?.hash && versionInfo.git.hash !== 'unknown' && (
                <span className="text-xs opacity-70">({versionInfo.git.hash})</span>
              )}
            </button>

            {showDetails && (
              <div className="fixed bottom-16 right-4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg p-4 text-xs z-50">
                <button
                  onClick={() => setShowDetails(false)}
                  className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                >
                  ✕
                </button>
                <div className="space-y-2 min-w-[250px]">
                  <div>
                    <span className="font-semibold">{t('footer.version')}:</span>{' '}
                    <span className="font-mono">{versionInfo.version}</span>
                  </div>
                  {versionInfo.git?.hash && versionInfo.git.hash !== 'unknown' && (
                    <>
                      <div>
                        <span className="font-semibold">{t('footer.gitHash')}:</span>{' '}
                        <span className="font-mono">{versionInfo.git.hash}</span>
                      </div>
                      <div>
                        <span className="font-semibold">{t('footer.branch')}:</span>{' '}
                        <span className="font-mono">{versionInfo.git.branch}</span>
                      </div>
                    </>
                  )}
                  <div>
                    <span className="font-semibold">{t('common.name')}:</span> {versionInfo.name}
                  </div>
                  <div className="pt-2 text-gray-500 dark:text-gray-400">
                    {versionInfo.description}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
